export default __webpack_public_path__ + "fe250f7b53677d28890089fed9641742.png";